module.exports = __webpack_public_path__ + "img/arrow6.0b6156e1.svg";